import cn from 'classnames';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'editor/src/store/hooks';
import { PluginName } from 'editor/src/store/plugins/types';
import updatePersonalizationOperation, {
  PersonalizationType,
} from 'editor/src/store/variants/operation/updateProductPersonalizationOperation';

import Accordion from 'editor/src/component/Accordion';
import RadioButtonElement, { ElementOption } from 'editor/src/component/RadioButtonElement';

import styles from '../ShopifyPersonalizationOptions/index.module.scss';

function InPagePersonalizationOptions() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const selectedOption = useSelector(
    (state): PersonalizationType =>
      state.design.globalPlugins.includes(PluginName.inPagePersonalization)
        ? 'inpage-personalization'
        : 'editor-personalization',
  );
  const [collapsed, setCollapsed] = useState(false);

  const onChange = useCallback((option: PersonalizationType) => {
    dispatch(updatePersonalizationOperation(option));
  }, []);

  const options: ElementOption<PersonalizationType>[] = [
    {
      value: 'inpage-personalization',
      label: t('In-page personalization'),
      content: t('In-page personalization content'),
    },
    {
      value: 'editor-personalization',
      label: t('Editor Personalization'),
      content: t('inpage personalization toggle-off content'),
    },
  ];

  const subheader = options.find((option) => option.value === selectedOption)?.label;

  return (
    <div className={cn(styles.shopifyOptionContainer, 'mb-2', 'pl-2', 'pr-2', { 'pb-2': !collapsed })}>
      <Accordion
        header={t('Type')}
        headerClassName={styles.header}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        subheader={subheader}
        subheaderClassName={styles.subheader}
      >
        <RadioButtonElement options={options} selected={selectedOption} onChange={onChange} />
      </Accordion>
    </div>
  );
}

export default React.memo(InPagePersonalizationOptions);
